module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (174).4946c4c6.jpg";